export interface MangaItem {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  category: string;
  tags: string[];
  description: string;
  rating: number;
  views: number;
  chapters: number;
  updateDate: string;
  status: 'ongoing' | 'completed';
  content?: string;
}

export interface CategoryItem {
  slug: string;
  name: string;
  icon: string;
  description: string;
  count: number;
}

export interface ReviewItem {
  id: string;
  username: string;
  avatar: string;
  rating: number;
  content: string;
  date: string;
}

export const categories: CategoryItem[] = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line', description: '浏览所有漫画作品', count: 48 },
  { slug: 'japanese', name: '日系漫画', icon: 'ri-sun-line', description: '经典日系漫画作品', count: 18 },
  { slug: 'doujinshi', name: '同人志', icon: 'ri-group-line', description: '精选同人创作', count: 12 },
  { slug: 'original', name: '原创本子', icon: 'ri-pencil-ruler-line', description: '原创漫画作品', count: 8 },
  { slug: 'romance', name: '恋爱题材', icon: 'ri-heart-line', description: '甜蜜恋爱故事', count: 10 },
  { slug: 'fantasy', name: '奇幻冒险', icon: 'ri-rocket-line', description: '奇幻世界冒险', count: 7 },
  { slug: 'slice-of-life', name: '日常治愈', icon: 'ri-home-smile-line', description: '温馨日常故事', count: 6 },
];

export const mangaList: MangaItem[] = [
  {
    id: '1',
    title: '樱花树下的约定',
    author: '山田花子',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20a%20young%20couple%20under%20a%20blooming%20cherry%20blossom%20tree%2C%20soft%20pink%20petals%20falling%2C%20warm%20spring%20lighting%2C%20romantic%20atmosphere%2C%20clean%20anime%20art%20style%20with%20delicate%20linework%20and%20pastel%20color%20palette%2C%20Japanese%20manga%20aesthetic&width=400&height=560&seq=manga-cover-01&orientation=portrait',
    category: 'japanese',
    tags: ['恋爱', '校园', '治愈'],
    description: '高中二年级的春日，樱花纷飞的校园里，两个性格迥异的少年少女因一本漫画书相遇。在共同追寻梦想的道路上，他们逐渐发现彼此心中深藏的秘密，一段纯真而深刻的青春物语就此展开。',
    rating: 4.8,
    views: 125000,
    chapters: 36,
    updateDate: '2026-08-05',
    status: 'ongoing',
  },
  {
    id: '2',
    title: '月光下的魔法使',
    author: '星野光',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20art%20of%20a%20magical%20girl%20with%20flowing%20silver%20hair%20under%20moonlight%2C%20sparkling%20stars%20and%20crystal%20magic%20effects%2C%20mystical%20fantasy%20atmosphere%2C%20elegant%20anime%20art%20style%20with%20purple%20and%20silver%20color%20scheme%2C%20Japanese%20manga%20cover%20design&width=400&height=560&seq=manga-cover-02&orientation=portrait',
    category: 'japanese',
    tags: ['奇幻', '魔法', '冒险'],
    description: '普通高中生月城玲奈在一个满月之夜遇到了神秘的魔法生物，从此获得了驾驭月光的力量。她必须在学业与守护城市之间找到平衡，同时揭开隐藏在月光背后的古老秘密。',
    rating: 4.6,
    views: 98000,
    chapters: 24,
    updateDate: '2026-08-04',
    status: 'ongoing',
  },
  {
    id: '3',
    title: '星空下的咖啡店',
    author: '有栖川零',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20a%20cozy%20coffee%20shop%20at%20night%20with%20warm%20lighting%2C%20a%20barista%20character%20smiling%20behind%20the%20counter%2C%20star%20filled%20sky%20visible%20through%20large%20windows%2C%20comforting%20slice%20of%20life%20atmosphere%2C%20clean%20anime%20art%20style%20with%20warm%20brown%20and%20golden%20tones&width=400&height=560&seq=manga-cover-03&orientation=portrait',
    category: 'original',
    tags: ['治愈', '日常', '美食'],
    description: '在城市的某个角落，有一家只在深夜营业的神秘咖啡店。每位到访的客人都有着不为人知的故事，而店长总能泡出一杯恰到好处的咖啡，温暖每一颗疲惫的心。',
    rating: 4.9,
    views: 156000,
    chapters: 48,
    updateDate: '2026-08-05',
    status: 'completed',
  },
  {
    id: '4',
    title: '异世界转生记',
    author: '田中太郎',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20art%20of%20a%20fantasy%20adventure%20scene%20with%20a%20hero%20wielding%20a%20sword%20in%20a%20medieval%20fantasy%20world%2C%20dragon%20silhouette%20in%20background%2C%20epic%20atmosphere%20with%20dramatic%20lighting%2C%20adventure%20isekai%20genre%2C%20clean%20anime%20art%20style%20with%20vibrant%20colors&width=400&height=560&seq=manga-cover-04&orientation=portrait',
    category: 'doujinshi',
    tags: ['异世界', '冒险', '战斗'],
    description: '普通上班族在加班途中意外穿越到剑与魔法的异世界。凭借前世积累的现代知识，他在这个危机四伏的世界中开辟出一条独特的生存之路，组建了最强的冒险者团队。',
    rating: 4.5,
    views: 210000,
    chapters: 52,
    updateDate: '2026-08-03',
    status: 'ongoing',
  },
  {
    id: '5',
    title: '下雨天和你',
    author: '雨宫凛',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20two%20characters%20sharing%20an%20umbrella%20on%20a%20rainy%20day%2C%20wet%20city%20street%20reflections%2C%20gentle%20melancholy%20atmosphere%2C%20soft%20blue%20and%20gray%20color%20palette%2C%20romantic%20slice%20of%20life%20anime%20style%20with%20delicate%20watercolor%20texture&width=400&height=560&seq=manga-cover-05&orientation=portrait',
    category: 'romance',
    tags: ['恋爱', '都市', '治愈'],
    description: '连续一个月的雨天，让两个素不相识的人在同一个公交站相遇。每次短暂的等待时光中，他们分享着各自的生活片段，一段细腻而温暖的都市恋情在雨声中悄然萌芽。',
    rating: 4.7,
    views: 89000,
    chapters: 20,
    updateDate: '2026-08-05',
    status: 'ongoing',
  },
  {
    id: '6',
    title: '龙之谷的守护者',
    author: '炎龙寺莲',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20art%20of%20a%20dragon%20rider%20character%20soaring%20through%20a%20mountainous%20valley%2C%20ancient%20ruins%20below%2C%20majestic%20fantasy%20landscape%20with%20golden%20sunset%20lighting%2C%20epic%20adventure%20atmosphere%2C%20clean%20anime%20art%20style&width=400&height=560&seq=manga-cover-06&orientation=portrait',
    category: 'fantasy',
    tags: ['奇幻', '冒险', '龙'],
    description: '在被遗忘的龙之谷深处，最后的龙族守护者与一位意外闯入的人类少女结下了不解之缘。古老的预言开始应验，他们必须携手面对即将到来的黑暗势力，守护世界的平衡。',
    rating: 4.4,
    views: 76000,
    chapters: 30,
    updateDate: '2026-08-02',
    status: 'ongoing',
  },
  {
    id: '7',
    title: '猫咪咖啡厅的日常',
    author: '猫田美咲',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20a%20cat%20cafe%20scene%20with%20various%20cute%20cats%20and%20a%20cheerful%20female%20character%2C%20cozy%20warm%20interior%20with%20sunlight%20streaming%20through%20windows%2C%20heartwarming%20slice%20of%20life%20atmosphere%2C%20clean%20anime%20art%20style%20with%20warm%20color%20palette&width=400&height=560&seq=manga-cover-07&orientation=portrait',
    category: 'slice-of-life',
    tags: ['治愈', '日常', '猫'],
    description: '辞去高压工作后，优子来到一家猫咪咖啡厅打工。在这里，她遇到了性格各异的猫咪和有趣的人们，在猫的陪伴下逐渐找回生活的节奏。每一话都是一个温暖治愈的小故事。',
    rating: 4.8,
    views: 67000,
    chapters: 42,
    updateDate: '2026-08-04',
    status: 'completed',
  },
  {
    id: '8',
    title: '剑与花的物语',
    author: '神代剑心',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20art%20of%20a%20samurai%20warrior%20in%20a%20field%20of%20white%20flowers%2C%20traditional%20Japanese%20setting%20with%20cherry%20blossoms%2C%20contrast%20between%20sword%20and%20nature%2C%20poetic%20atmosphere%2C%20clean%20anime%20art%20style%20with%20traditional%20Japanese%20aesthetic&width=400&height=560&seq=manga-cover-08&orientation=portrait',
    category: 'doujinshi',
    tags: ['历史', '战斗', '和风'],
    description: '战国时代末期，一位失去主君的年轻武士在流浪中遇到了一位神秘的花道家。剑术与花道的碰撞，带来了对生命意义的全新领悟。一段充满刀光剑影与和风雅韵的传奇就此展开。',
    rating: 4.6,
    views: 54000,
    chapters: 18,
    updateDate: '2026-08-01',
    status: 'ongoing',
  },
  {
    id: '9',
    title: '星空观测部',
    author: '夜空星',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20students%20gathered%20on%20a%20school%20rooftop%20at%20night%20with%20telescopes%2C%20beautiful%20starry%20sky%20with%20milky%20way%2C%20gentle%20atmosphere%20of%20friendship%20and%20wonder%2C%20clean%20anime%20art%20style%20with%20deep%20blue%20and%20starlight&width=400&height=560&seq=manga-cover-09&orientation=portrait',
    category: 'original',
    tags: ['校园', '治愈', '天文'],
    description: '天文部只有三名成员，但他们每天晚上都会在天台上观测星空。在这片共同的星空下，三个性格迥异的少年少女建立起深厚的友谊，一起追逐各自的梦想。',
    rating: 4.7,
    views: 43000,
    chapters: 28,
    updateDate: '2026-08-05',
    status: 'completed',
  },
  {
    id: '10',
    title: '冒险者酒馆',
    author: '竜崎ダンジョン',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20art%20of%20a%20fantasy%20tavern%20interior%20with%20adventurers%20gathering%20around%20a%20wooden%20table%2C%20warm%20fireplace%20glow%2C%20fantasy%20RPG%20atmosphere%2C%20various%20character%20classes%20visible%2C%20clean%20anime%20art%20style%20with%20warm%20tavern%20aesthetic&width=400&height=560&seq=manga-cover-10&orientation=portrait',
    category: 'fantasy',
    tags: ['奇幻', '冒险', '美食'],
    description: '在迷宫都市的中心，有一家冒险者们最爱聚集的酒馆。这里不仅提供最美味的料理，更是各种冒险故事的交汇点。每一话都讲述一位冒险者的传奇经历。',
    rating: 4.3,
    views: 38000,
    chapters: 15,
    updateDate: '2026-07-30',
    status: 'ongoing',
  },
  {
    id: '11',
    title: '夏日和蝉鸣',
    author: '夏川涼子',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20a%20summer%20scene%20in%20rural%20Japan%2C%20a%20girl%20in%20school%20uniform%20by%20a%20river%2C%20cicada%20sound%20vibe%2C%20bright%20sunlight%20filtering%20through%20trees%2C%20nostalgic%20summer%20atmosphere%2C%20clean%20anime%20art%20style%20with%20vibrant%20green%20and%20blue&width=400&height=560&seq=manga-cover-11&orientation=portrait',
    category: 'slice-of-life',
    tags: ['治愈', '夏季', '乡村'],
    description: '城市少女小夏暑假回到乡下祖母家，在蝉鸣声中重温童年的记忆。与儿时玩伴的重逢、夏祭的烟火、田间的蛙鸣，每一个瞬间都让人怀念不已。',
    rating: 4.5,
    views: 35000,
    chapters: 16,
    updateDate: '2026-08-04',
    status: 'completed',
  },
  {
    id: '12',
    title: '秘密花园',
    author: '花園詩織',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20a%20hidden%20garden%20full%20of%20colorful%20flowers%2C%20a%20mysterious%20girl%20with%20long%20hair%20tending%20to%20plants%2C%20magical%20atmosphere%20with%20fireflies%20and%20soft%20glowing%20lights%2C%20fairy%20tale%20aesthetic%2C%20clean%20anime%20art%20style&width=400&height=560&seq=manga-cover-12&orientation=portrait',
    category: 'original',
    tags: ['奇幻', '治愈', '植物'],
    description: '在一栋古老洋房的围墙后面，隐藏着一个不为人知的秘密花园。少女诗织是这片花园的守护者，每一朵花都承载着一段尘封的记忆和故事。',
    rating: 4.6,
    views: 52000,
    chapters: 22,
    updateDate: '2026-08-03',
    status: 'ongoing',
  },
];

export const reviews: ReviewItem[] = [
  {
    id: '1',
    username: '漫画迷小王',
    avatar: '',
    rating: 5,
    content: '画面质量太棒了！每一页都能感受到作者的心血，分类检索也很方便，强烈推荐给所有二次元爱好者！',
    date: '2026-07-28',
  },
  {
    id: '2',
    username: '樱花前线',
    avatar: '',
    rating: 5,
    content: '终于找到一个可以放心看正版漫画的平台了，更新速度很快，收藏功能超实用，每天都在追更。',
    date: '2026-07-25',
  },
  {
    id: '3',
    username: '二次元老司机',
    avatar: '',
    rating: 4,
    content: '同人志资源非常丰富，很多小众作品也能在这里找到，界面简洁美观，阅读体验很棒。希望原创区能再多一些作品。',
    date: '2026-07-20',
  },
  {
    id: '4',
    username: '星空下的猫',
    avatar: '',
    rating: 5,
    content: '从朋友推荐过来的，一用就爱上了！高清画质真的太享受了，而且分类很清晰，找漫画特别方便。',
    date: '2026-07-18',
  },
  {
    id: '5',
    username: '日系文化爱好者',
    avatar: '',
    rating: 5,
    content: '支持正版！这个平台让我看到了国内二次元文化的进步，内容丰富，更新及时，已经推荐给身边所有漫友了。',
    date: '2026-07-15',
  },
  {
    id: '6',
    username: '追更小达人',
    avatar: '',
    rating: 4,
    content: '每天都在用，更新提醒很及时，再也不用担心错过更新的漫画了。希望能增加夜间模式，晚上看书更方便。',
    date: '2026-07-12',
  },
];

export const faqList = [
  {
    question: '本子网站是什么？',
    answer: '本子网站是一个专为二次元爱好者打造的正版漫画在线阅读平台，提供海量日系漫画、同人志和原创本子内容。我们致力于提供高品质、正版的阅读体验，支持高清浏览、分类检索和收藏管理。',
  },
  {
    question: '如何注册成为会员？',
    answer: '点击网站右上角的"注册"按钮，填写邮箱地址和设置密码即可完成注册。注册后即可免费体验平台上的所有内容，无需支付任何费用。',
  },
  {
    question: '本子网站上的漫画都是正版的吗？',
    answer: '是的，本子网站上的所有漫画内容均经过正版授权。我们与多家日本出版社和独立创作者建立了合作关系，确保所有内容均为合法授权的正版作品。',
  },
  {
    question: '支持哪些设备阅读？',
    answer: '本子网站支持PC端、平板和手机端浏览。无论你使用什么设备，都能享受高清流畅的阅读体验。推荐使用Chrome或Safari浏览器获得最佳效果。',
  },
  {
    question: '如何收藏喜欢的漫画？',
    answer: '登录后，在漫画详情页点击"收藏"按钮即可将该漫画加入你的收藏列表。你可以随时在个人中心查看和管理你的收藏。',
  },
  {
    question: '更新频率是怎样的？',
    answer: '我们与创作者保持紧密合作，确保漫画更新及时。大部分连载作品每周更新1-2话，已完结作品可直接阅读全部章节。你可以在首页"最新更新"区域查看最近更新的作品。',
  },
];

export const aboutStats = [
  { label: '注册用户', value: '500,000+', icon: 'ri-user-line' },
  { label: '漫画作品', value: '5,000+', icon: 'ri-book-open-line' },
  { label: '章节总数', value: '120,000+', icon: 'ri-file-list-3-line' },
  { label: '日活跃用户', value: '80,000+', icon: 'ri-fire-line' },
];